import { AbstractControl, ValidationErrors } from '@angular/forms';
import { NotificationPlanRule } from '../../../index';

export const ValidatorEmailsMessage = 'No email has been added';

export function recipientValidator(control: AbstractControl): ValidationErrors | null {
  if (!control?.value) return null;

  const { emails, rule } = control.value;

  const specifiedEmailsChecked = Boolean(rule & NotificationPlanRule.SpecifiedEmails);

  if (specifiedEmailsChecked && emails.length === 0) {
    return { emails: { message: ValidatorEmailsMessage } };
  }

  return null;
}
